import { CloseOutlined } from '@ant-design/icons';
import { Button, Typography } from 'antd';
import type { ReactNode } from 'react';

/**
 * Раскладка «список слева — форма справа».
 *
 * Добавление записи (документа, перевода, отпуска) открывается панелью рядом
 * со списком, а не всплывающим окном поверх него: таблица остаётся на виду,
 * и видно, с чем новая запись соседствует (сроки, пересечения периодов).
 */
export function SidePanelLayout({
  panel,
  title,
  onClose,
  children,
}: {
  /** null — панель закрыта, список на всю ширину. */
  panel: ReactNode | null;
  title?: ReactNode;
  onClose?: () => void;
  children: ReactNode;
}) {
  return (
    <div style={{ display: 'flex', gap: 16, alignItems: 'flex-start' }}>
      <div style={{ flex: 1, minWidth: 0 }}>{children}</div>
      {panel && (
        <div className="tms-side-panel">
          <div className="tms-side-panel-head">
            <Typography.Text strong style={{ fontSize: 15 }}>
              {title}
            </Typography.Text>
            <Button type="text" size="small" icon={<CloseOutlined />} onClick={onClose} />
          </div>
          {panel}
        </div>
      )}
    </div>
  );
}

/** Шапка раздела: заголовок слева, действия справа. */
export function SectionHeader({ title, extra }: { title: ReactNode; extra?: ReactNode }) {
  return (
    <div className="tms-section-head">
      <Typography.Title level={5} style={{ margin: 0 }}>
        {title}
      </Typography.Title>
      {extra}
    </div>
  );
}
